
export const phoneIsValid = phone => new RegExp(
  '^(\\+)?375(\\s+)?\\(?(17|29|33|44|25)\\)?(\\s+)?[0-9]{3}-?[0-9]{2}-?[0-9]{2}$'
).test(phone)

export const ceilNumberIsValid = value => new RegExp('^\\d+$').test(value)
